export const ru = {
    'no-phrases-for-dynamic-campaigns':
        'Нельзя добавлять фразы в группы Динамических кампаний',
    'no-phrases-for-smart-banners': 'Нельзя добавлять фразы в Смарт-баннерах'
};
